import { createWebHistory, createRouter } from "vue-router";
import Login from "./components/Login.vue";
import Register from "./components/Register.vue";
// lazy-loaded
const Profile = () => import(/* webpackChunkName: "Profile" */"./components/Profile.vue")
const UserAppModules = () => import(/* webpackChunkName: "User App Modules" */"./modules/systemAdmin/components/UserAppModules.vue")
const MenuOption = () => import(/* webpackChunkName: "MenuOption" */"/src/modules/zzz/MenuOption.vue")
//const ManTab = () => import("./modules/zzz/ManTab.vue")
const ControlCrud = () => import("./modules/workSpace/components/crud/ControlCrud.vue")
const CheckListCrud = () => import("./modules/workSpace/components/crud/CheckListCrud.vue")
//src\modules\admin\components\Modules.vue

//const OpcA = () => import(/* webpackChunkName: "Opcion A" */"/src/modules/zzz/opca.vue")
//const ManTab = () => import(/* webpackChunkName: "Admin Tables" */"/src/modules/zzz/mantab.vue")

const routes = [
   {
      path: "/",
      component: Login,
   },
   {
      path: "/login",
      component: Login,
   },
   {
      path: "/register",
      component: Register,
   },
   {
      path: "/profile",
      name: "profile",
      // lazy-loaded
      component: Profile,
   },
   {
      path: "/userAppModules",
      name: "userAppModules",
      // lazy-loaded
      component: UserAppModules,
   },
   {
      path: "/controlcrud",
      name: "controlCrud",
      // lazy-loaded
      component: ControlCrud,
   },
   {
      path: "/checkListcrud",
      name: "checkListCrud",
      // lazy-loaded
      component: CheckListCrud,
   },
   
   {
      path: "/menuoption",
      name: "menuoption",
      // lazy-loaded
      component: MenuOption,
   },
   {
      path: "/boardtablelist",
      name: "boardtablelist",
      // lazy-loaded
      component: () => import("./modules/workSpace/components/BoardTableTypeList.vue"),    //MdContentTableTypeList,
      children: [
         {
            path: "addV310",
            component: () => import("./modules/voucher310/components/UpWizardV310.vue"),
            props: route => ({ dataFromCard: route.query.dfc })
         },
         {
            path: "form",
            component: () => import("./modules/workSpace/components/form/InputForm.vue"),
            props: route => ({ dataFromCard: route.query.dfc })
         },
         {
            path: "mrcp",
            component: () => import("./modules/workSpace/components/form/ShowMail.vue"),
            props: route => ({ dataFromCard: route.query.dfc })
         }         
      ]
   },
   /*
   {
      path: "/mantab",
      name: "mantab",
      // lazy-loaded
      component: ManTab,
   },
   */
];

const router = createRouter({
   history: createWebHistory(),
   routes,
});

export default router;